<template>
  <v-card class="tablesize">
    <block v-if="loading"></block>
    <v-btn @click="close" elevation="0" color="red" class="close-btn"
      ><v-icon>mdi-close</v-icon></v-btn
    >
    <div class="py-10 px-4">
      <v-card-title class="font-weight-bold"><h3>Exportar CSV</h3></v-card-title>
      <v-card-text class="mt-5">
        <!-- month & year -->
        <v-row class="mt-2">
          <v-col cols="12" md="6">
            <v-select
              v-model="search.month"
              :items="monthList"
              label="Mes"
              outlined
              attach
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              v-model="search.year"
              :items="yearList"
              label="Año"
              outlined
              attach
              dense
            ></v-select>
          </v-col>
        </v-row>

        <!-- Selector de Sucursal -->
        <v-row v-if="showBranchSelector && $store.getters['rolesUser/getCustomRole'](93)" class="mt-2">
          <v-col cols="12" md="6">
            <v-select 
              :value="selectedBranch"
              @input="onBranchChange"
              :items="branches"
              item-text="BranchName"
              item-value="ID_Branch"
              label="Sucursal"
              :hint="currentBranch ? `${currentBranch}` : ''"
              persistent-hint
              dense
              outlined
              clearable
              hide-details="auto"
            />
          </v-col>
        </v-row>
        <!-- month & year -->
       <!--  <v-btn
          @click.prevent="getSalesTaxpayer"
        >
          test
        </v-btn> -->
        <!-- Select all -->

        <v-row>
            <v-col cols="12">
                <v-radio-group v-model="dataType">
                    <v-radio label="Ver reporte con datos de prueba" value="00"></v-radio>
                    <v-radio label="Ver reporte con datos de producción" value="01"></v-radio>
                </v-radio-group>
            </v-col>
        </v-row>

        <v-radio-group v-model="selectedRadio">
          <v-row class="my-3">
            <v-col cols="12" md="6" sm="6">
              <v-radio
                label="Seleccionar todos"
                value="selectAll"
                @click="handleRadioClick('selectAll')"
              ></v-radio>
            </v-col>
            <v-col cols="12" md="6" sm="6">
              <v-radio
                label="Desmarcar todos"
                value="deselectAll"
                @click="handleRadioClick('deselectAll')"
              ></v-radio>
            </v-col>
          </v-row>
        </v-radio-group>
        <!-- Select all -->

        <!-- inputs -->
        <h3>Opciones</h3>
        <v-row class="mt-3"  v-if="(TipoPlan != 'Emprendedor' && TipoPlan != 'Ecoanual' && TipoPlan != 'Ecoanual CONAMYPE')">
         
          <v-col cols="6" v-for="(option, index) in options" :key="index">
            <v-checkbox
              v-model="selectedOptions"
              :label="option.text"
              :value="option.value"
            ></v-checkbox>
          </v-col>

          <v-col cols="12" class="mt-5 d-flex justify-center">
            <v-btn class="btn-save" @click="showSelections"
              ><v-icon class="mr-3">mdi-download</v-icon> Guardar CSV</v-btn
            >
          </v-col>
        </v-row>
        <v-row class="mt-3"  v-if="(TipoPlan === 'Emprendedor' || TipoPlan === 'Ecoanual' || TipoPlan === 'Ecoanual CONAMYPE')">
         
         <v-col cols="6" v-for="(option, index) in options2" :key="index">
           <v-checkbox
             v-model="selectedOptions"
             :label="option.text"
             :value="option.value"
           ></v-checkbox>
         </v-col>

         <v-col cols="12" class="mt-5 d-flex justify-center">
           <v-btn class="btn-save" @click="showSelections"
             ><v-icon class="mr-3">mdi-download</v-icon> Guardar CSV</v-btn
           >
         </v-col>
       </v-row>
        <!-- inputs -->
      </v-card-text>
    </div>
    <alerts
      v-if="alert.show"
      v-on:close_alert="closeAlert"
      v-on:accept_alert="acceptAlert"
      :properties="alert"
    ></alerts>
  </v-card>
</template>

<script>
import Block from "@/components/Block";
import alerts from "@/components/Alerts.vue";
import { convertToCSV, getCurrentDateTimeString } from "../../../helpers/convertToCSV";
export default {
  name: "AccountingExportCSV",

  props: ["win"],

  components: { Block, alerts },

  data() {
    return {
      dataType: '01',
      panel: 0,
      tab: null,
      key: 0,
      search: {
        month: null,
        year: null,
        dataType: '',
        ID_Branch: null
      },
      alert: {
        type: "success",
        show: false,
        header: "",
        body: "",
      },
      // Datos para el selector de sucursal
      showBranchSelector: true,
      selectedBranch: null,
      branches: [],
      currentBranch: "",
      selectedOptions: [],
      options: [
        {
          text: "Ventas Contribuyente",
          value: "vc",
          titleHeaders: [
              'FECHA EMISIÓN DEL DOCUMENTO',
              'CLASE DE DOCUMENTO',
              'TIPO DE DOCUMENTO',
              'NÚMERO DE RESOLUCIÓN',
              'NUMERO DE SERIE DE DOCUMENTO',
              'NÚMERO DE DOCUMENTO',
              'NÚMERO DE CONTROL INTERNO',
              'NIT O NRC DEL CLIENTE',
              'NOMBRE, RAZÓN SOCIAL O DENOMINACIÓN',
              'VENTAS EXENTAS',
              'VENTAS NO SUJETAS',
              'VENTAS GRAVADAS LOCALES',
              'DÉBITO FISCAL',
              'VENTAS A CUENTA DE TERCEROS NO DOMICILIADOS',
              'DÉBITO FISCAL POR VENTA A CUENTA DE TERCEROS',
              'TOTAL VENTAS',
              'DUI DEL CLIENTE',
              'TIPO DE OPERACION (Renta)',
              'TIPO DE INGRESO (Renta)',
              'NÚMERO DE ANEXO'
          ],
          dataHeaders: [
              'FECHA EMISIÓN DEL DOCUMENTO',
              'CLASE DE DOCUMENTO',
              'TIPO DE DOCUMENTO',
              'NÚMERO DE RESOLUCIÓN',
              'NUMERO DE SERIE DE DOCUMENTO',
              'NÚMERO DE DOCUMENTO',
              'NÚMERO DE CONTROL INTERNO',
              'NIT O NRC DEL CLIENTE',
              'NOMBRE, RAZÓN SOCIAL O DENOMINACIÓN',
              'VENTAS EXENTAS',
              'VENTAS NO SUJETAS',
              'VENTAS GRAVADAS LOCALES',
              'DÉBITO FISCAL',
              'VENTAS A CUENTA DE TERCEROS NO DOMICILIADOS',
              'DÉBITO FISCAL POR VENTA A CUENTA DE TERCEROS',
              'TOTAL VENTAS',
              'DUI DEL CLIENTE',
              'TIPO DE OPERACION (Renta)',
              'TIPO DE INGRESO (Renta)',
              'NÚMERO DE ANEXO'
          ],
        },
        {
          text: "Ventas Consumidor final",
          value: "vcf",
          titleHeaders: [
            "InvoiceDate",
            "ClaseDeDocumento",
            "TipoDeDocumento",
            "NumeroDeResolucion",
            "SerieDeDocumento",
            "NumeroDeControlInternoDel",
            "NumeroDeControlInternoDelAl",
            "NumeroDeDocumentoDel",
            "NumeroDeDocumentoAl",
            "NoDeMaquinaRegistradora",
            "VentasExentas",
            "VentasInternasExentasNoSujetasAProporcionalidad",
            "VentasNoSujetas",
            "VentasGravadasLocales",
            "ExportacionesDentroDelAreaCentroamericana",
            "ExportacionesFueraDelAreaCentroamericana",
            "ExportacionesDeServicios",
            "VentasAZonasFrancasYDPATasaCero",
            "VentaACuentaDeTercerosNoDomiciliados",
            "TotalVentas",
            "TipoOperacionRenta",
            "TipoDeIngresoRenta",
            "NumeroDeAnexo"
          ],
          dataHeaders: [
            "InvoiceDate",
            "ClaseDeDocumento",
            "TipoDeDocumento",
            "NumeroDeResolucion",
            "SerieDeDocumento",
            "NumeroDeControlInternoDel",
            "NumeroDeControlInternoDelAl",
            "NumeroDeDocumentoDel",
            "NumeroDeDocumentoAl",
            "NoDeMaquinaRegistradora",
            "VentasExentas",
            "VentasInternasExentasNoSujetasAProporcionalidad",
            "VentasNoSujetas",
            "VentasGravadasLocales",
            "ExportacionesDentroDelAreaCentroamericana",
            "ExportacionesFueraDelAreaCentroamericana",
            "ExportacionesDeServicios",
            "VentasAZonasFrancasYDPATasaCero",
            "VentaACuentaDeTercerosNoDomiciliados",
            "TotalVentas",
            "TipoOperacionRenta",
            "TipoDeIngresoRenta",
            "NumeroDeAnexo"
          ]
        },
        {
          text: "Documentos Invalidados",
          value: "da",
          titleHeaders: [
            "NÚMERO DE RESOLUCIÓN",
            "CLASE DE DOCUMENTO",
            "DESDE (PREIMPRESO)",
            "HASTA (PREIMPRESO)",
            "TIPO DE DOCUMENTO",
            "TIPO DE DETALLE",
            "SERIE",
            "DESDE",
            "HASTA",
            "CÓDIGO DE GENERACIÓN"
          ],
          dataHeaders: [
            "NÚMERO DE RESOLUCIÓN",
            "CLASE DE DOCUMENTO",
            "DESDE (PREIMPRESO)",
            "HASTA (PREIMPRESO)",
            "TIPO DE DOCUMENTO",
            "TIPO DE DETALLE",
            "SERIE",
            "DESDE",
            "HASTA",
            "CÓDIGO DE GENERACIÓN"
          ]
        },
        {
          text: "Percepción IVA del 1% efectuada por el declarante (C169)",
          value: "crr",
          titleHeaders: [
              "NIT DEL AGENTE",
              "FECHA DE EMISIÓN",
              "TIPO DE DOCUMENTO",
              "SERIE",
              "NÚMERO DE DOCUMENTO",
              "MONTO SUJETO",
              "MONTO RETENCIÓN 1%",
              "DUI DEL AGENTE",
              "NÚMERO DE ANEXO"
          ],
          dataHeaders: [
              "NIT DEL AGENTE",
              "FECHA DE EMISIÓN",
              "TIPO DE DOCUMENTO",
              "SERIE",
              "NÚMERO DE DOCUMENTO",
              "MONTO SUJETO",
              "MONTO RETENCIÓN 1%",
              "DUI DEL AGENTE",
              "NÚMERO DE ANEXO"
          ],
        },
        {
          text: "Compras",
          value: "c",
          titleHeaders: [
              "FECHA DE EMISIÓN",
              "CLASE DE DOCUMENTO",
              "TIPO DE DOCUMENTO",
              "NÚMERO DE DOCUMENTO",
              "NIT O NRC DEL PROVEEDOR",
              "NOMBRE DEL PROVEEDOR",
              "COMPRAS INTERNAS EXENTAS Y/O NO SUJETAS",
              "INTERNACIONES EXENTAS Y/O NO SUJETAS",
              "IMPORTACIONES EXENTAS Y/O NO SUJETAS",
              "COMPRAS INTERNAS GRAVADAS",
              "INTERNACIONES GRAVADAS DE BIENES",
              "IMPORTACIONES GRAVADAS DE BIENES",
              "IMPORTACIONES GRAVADAS DE SERVICIOS",
              "CRÉDITO FISCAL",
              "TOTAL DE COMPRAS",
              "DUI DEL PROVEEDOR",
              "TIPO DE OPERACIÓN",
              "CLASIFICACIÓN",
              "SECTOR",
              "TIPO DE COSTO / GASTO",
              "NÚMERO DE ANEXO"
          ],
          dataHeaders:[
              "FECHA DE EMISIÓN",
              "CLASE DE DOCUMENTO",
              "TIPO DE DOCUMENTO",
              "NÚMERO DE DOCUMENTO",
              "NIT O NRC DEL PROVEEDOR",
              "NOMBRE DEL PROVEEDOR",
              "COMPRAS INTERNAS EXENTAS Y/O NO SUJETAS",
              "INTERNACIONES EXENTAS Y/O NO SUJETAS",
              "IMPORTACIONES EXENTAS Y/O NO SUJETAS",
              "COMPRAS INTERNAS GRAVADAS",
              "INTERNACIONES GRAVADAS DE BIENES",
              "IMPORTACIONES GRAVADAS DE BIENES",
              "IMPORTACIONES GRAVADAS DE SERVICIOS",
              "CRÉDITO FISCAL",
              "TOTAL DE COMPRAS",
              "DUI DEL PROVEEDOR",
              "TIPO DE OPERACIÓN",
              "CLASIFICACIÓN",
              "SECTOR",
              "TIPO DE COSTO / GASTO",
              "NÚMERO DE ANEXO"
          ],
        },
        {
          text: "Compras Sujetos Excluidos",
          value: "cse",
          titleHeaders: [
            'TIPO DE DOCUMENTO',
            'NÚMERO DE NIT, DUI U OTRO DOCUMENTO',
            'NOMBRE, RAZÓN SOCIAL O DENOMINACIÓN',
            'FECHA DE EMISIÓN DE DOCUMENTO',
            'NÚMERO DE SERIE DEL DOCUMENTO',
            'NÚMERO DE DOCUMENTO',
            'MONTO DE LA OPERACIÓN',
            'MONTO DE LA RETENCIÓN IVA 13%',
            'TIPO DE OPERACIÓN',
            'CLASIFICACIÓN',
            'SECTOR',
            'TIPO DE COSTO/GASTO',
            'NÚMERO DE ANEXO'
          ],
          dataHeaders: [
            'TIPO DE DOCUMENTO',
            'NÚMERO DE NIT, DUI U OTRO DOCUMENTO',
            'NOMBRE, RAZÓN SOCIAL O DENOMINACIÓN',
            'FECHA DE EMISIÓN DE DOCUMENTO',
            'NÚMERO DE SERIE DEL DOCUMENTO',
            'NÚMERO DE DOCUMENTO',
            'MONTO DE LA OPERACIÓN',
            'MONTO DE LA RETENCIÓN IVA 13%',
            'TIPO DE OPERACIÓN',
            'CLASIFICACIÓN',
            'SECTOR',
            'TIPO DE COSTO/GASTO',
            'NÚMERO DE ANEXO'
          ],
        },
        { text: "Percepciones", value: "p", 
        titleHeaders:  [
              "NIT AGENTE",
              "FECHA DE EMISIÓN",
              "TIPO DE DOCUMENTO",
              "SERIE DE DOCUMENTO",
              "NUMERO DE DOCUMENTO",
              "MONTO SUJETO",
              "MONTO DE LA PERCEPCION",
              "DUI AGENTE",
              "NUMERO DE ANEXO"
          ], dataHeaders:  [
              "NIT AGENTE",
              "FECHA DE EMISIÓN",
              "TIPO DE DOCUMENTO",
              "SERIE DE DOCUMENTO",
              "NUMERO DE DOCUMENTO",
              "MONTO SUJETO",
              "MONTO DE LA PERCEPCION",
              "DUI AGENTE",
              "NUMERO DE ANEXO"
            ] },
        {
          text: "Anticipo a Cuenta",
          value: "ac",
          titleHeaders: [
              "NIT SUJETO",
              "FECHA DE EMISIÓN DEL DOCUMENTO",
              "NÚMERO DE RESOLUCIÓN",
              "SERIE DE DOCUMENTO",
              "NÚMERO DE DOCUMENTO",
              "MONTO SUJETO",
              "MONTO DEL ANTICIPO A CUENTA 2%",
              "DUI SUJETO",
              "NÚMERO DE ANEXO"
          ],
          dataHeaders: [
              "NIT SUJETO",
              "FECHA DE EMISIÓN DEL DOCUMENTO",
              "NÚMERO DE RESOLUCIÓN",
              "SERIE DE DOCUMENTO",
              "NÚMERO DE DOCUMENTO",
              "MONTO SUJETO",
              "MONTO DEL ANTICIPO A CUENTA 2%",
              "DUI SUJETO",
              "NÚMERO DE ANEXO"
          ],
        },
        {
          text: "Anticipo a cuenta al declarante (C161)",
          value: "img",
          titleHeaders: [
              "NIT AGENTE",
              "FECHA EMISIÓN DEL DOCUEMNTO",
              "SERIE DE DOCUMENTO",
              "NÚMERO DE DOCUMENTO",
              "Monto sujeto",
              "Monto del anticipo a cuenta 2%",
              "DUI AGENTE",
              "Número DE ANEXO"
          ],
          dataHeaders: [
              "NIT AGENTE",
              "FECHA EMISIÓN DEL DOCUEMNTO",
              "SERIE DE DOCUMENTO",
              "NÚMERO DE DOCUMENTO",
              "Monto sujeto",
              "Monto del anticipo a cuenta 2%",
              "DUI AGENTE",
              "Número DE ANEXO"
          ]
        },
        {
          text: "Retención IVA del 1% efectuadas al declarante (C162)",
          value: "rid",
          titleHeaders: [
              "nit_agente",
              "fecha_emision",
              "tipo_documento",
              "serie",
              "numero_documento",
              "monto_sujeto",
              "monto_retencion",
              "dui_agente",
              "numero_anexo",
          ],
          dataHeaders: [
              "nit_agente",
              "fecha_emision",
              "tipo_documento",
              "serie",
              "numero_documento",
              "monto_sujeto",
              "monto_retencion",
              "dui_agente",
              "numero_anexo",
          ],
        },
        {
          text: "Ventas gravadas por cuenta de terceros domiciliados (C108)",
          value: "bi",
          titleHeaders: [
            "nit_nrc",
            "nombre_mandante",
            "fecha_documento",
            "tipo_documento",
            "numero_serie",
            "numero_resolucion",
            "numero_documento",
            "monto_operacion",
            "iva_operacion",
            "numero_serie_liquidacion",
            "numero_resolucion_liquidacion",
            "numero_documento_liquidacion",
            "fecha_emision_liquidacion",
            "dui_mandante",
            "numero_anexo",
          ],
          dataHeaders: [
            "nit_nrc",
            "nombre_mandante",
            "fecha_documento",
            "tipo_documento",
            "numero_serie",
            "numero_resolucion",
            "numero_documento",
            "monto_operacion",
            "iva_operacion",
            "numero_serie_liquidacion",
            "numero_resolucion_liquidacion",
            "numero_documento_liquidacion",
            "fecha_emision_liquidacion",
            "dui_mandante",
            "numero_anexo",
          ],
        },
        {
          text: "Percepción IVA del 1% efectuada al declarante (C163)",
          value: "pid",
          titleHeaders: [
            "nit_agente",
            "fecha_emision",
            "tipo_documento",
            "tipo_documento",
            "serie_documento",
            "numero_documento",
            "monto_sujeto",
            "monto_percepcion",
            "dui_agente",
            "numero_anexo",
          ],
          dataHeaders: [
            "nit_agente",
            "fecha_emision",
            "tipo_documento",
            "tipo_documento",
            "serie_documento",
            "numero_documento",
            "monto_sujeto",
            "monto_percepcion",
            "dui_agente",
            "numero_anexo",
          ],
        },
      ],
      yearList: [],
      monthList: [
        { text: "Enero", value: 1 },
        { text: "Febrero", value: 2 },
        { text: "Marzo", value: 3 },
        { text: "Abril", value: 4 },
        { text: "Mayo", value: 5 },
        { text: "Junio", value: 6 },
        { text: "Julio", value: 7 },
        { text: "Agosto", value: 8 },
        { text: "Septiembre", value: 9 },
        { text: "Octubre", value: 10 },
        { text: "Noviembre", value: 11 },
        { text: "Diciembre", value: 12 },
      ],
      options2: [
        {
          text: "Ventas Contribuyente",
          value: "vc",
          titleHeaders: [
              'FECHA EMISIÓN DEL DOCUMENTO',
              'CLASE DE DOCUMENTO',
              'TIPO DE DOCUMENTO',
              'NÚMERO DE RESOLUCIÓN',
              'NUMERO DE SERIE DE DOCUMENTO',
              'NÚMERO DE DOCUMENTO',
              'NÚMERO DE CONTROL INTERNO',
              'NIT O NRC DEL CLIENTE',
              'NOMBRE, RAZÓN SOCIAL O DENOMINACIÓN',
              'VENTAS EXENTAS',
              'VENTAS NO SUJETAS',
              'VENTAS GRAVADAS LOCALES',
              'DÉBITO FISCAL',
              'VENTAS A CUENTA DE TERCEROS NO DOMICILIADOS',
              'DÉBITO FISCAL POR VENTA A CUENTA DE TERCEROS',
              'TOTAL VENTAS',
              'DUI DEL CLIENTE',
              'TIPO DE OPERACION (Renta)',
              'TIPO DE INGRESO (Renta)',
              'NÚMERO DE ANEXO'
          ],
          dataHeaders: [
              'FECHA EMISIÓN DEL DOCUMENTO',
              'CLASE DE DOCUMENTO',
              'TIPO DE DOCUMENTO',
              'NÚMERO DE RESOLUCIÓN',
              'NUMERO DE SERIE DE DOCUMENTO',
              'NÚMERO DE DOCUMENTO',
              'NÚMERO DE CONTROL INTERNO',
              'NIT O NRC DEL CLIENTE',
              'NOMBRE, RAZÓN SOCIAL O DENOMINACIÓN',
              'VENTAS EXENTAS',
              'VENTAS NO SUJETAS',
              'VENTAS GRAVADAS LOCALES',
              'DÉBITO FISCAL',
              'VENTAS A CUENTA DE TERCEROS NO DOMICILIADOS',
              'DÉBITO FISCAL POR VENTA A CUENTA DE TERCEROS',
              'TOTAL VENTAS',
              'DUI DEL CLIENTE',
              'TIPO DE OPERACION (Renta)',
              'TIPO DE INGRESO (Renta)',
              'NÚMERO DE ANEXO'
          ],
        },
        {
          text: "Ventas Consumidor final",
          value: "vcf",
          titleHeaders: [
            "InvoiceDate",
            "ClaseDeDocumento",
            "TipoDeDocumento",
            "NumeroDeResolucion",
            "SerieDeDocumento",
            "NumeroDeControlInternoDel",
            "NumeroDeControlInternoDelAl",
            "NumeroDeDocumentoDel",
            "NumeroDeDocumentoAl",
            "NoDeMaquinaRegistradora",
            "VentasExentas",
            "VentasInternasExentasNoSujetasAProporcionalidad",
            "VentasNoSujetas",
            "VentasGravadasLocales",
            "ExportacionesDentroDelAreaCentroamericana",
            "ExportacionesFueraDelAreaCentroamericana",
            "ExportacionesDeServicios",
            "VentasAZonasFrancasYDPATasaCero",
            "VentaACuentaDeTercerosNoDomiciliados",
            "TotalVentas",
            "TipoOperacionRenta",
            "TipoDeIngresoRenta",
            "NumeroDeAnexo"
          ],
          dataHeaders: [
            "InvoiceDate",
            "ClaseDeDocumento",
            "TipoDeDocumento",
            "NumeroDeResolucion",
            "SerieDeDocumento",
            "NumeroDeControlInternoDel",
            "NumeroDeControlInternoDelAl",
            "NumeroDeDocumentoDel",
            "NumeroDeDocumentoAl",
            "NoDeMaquinaRegistradora",
            "VentasExentas",
            "VentasInternasExentasNoSujetasAProporcionalidad",
            "VentasNoSujetas",
            "VentasGravadasLocales",
            "ExportacionesDentroDelAreaCentroamericana",
            "ExportacionesFueraDelAreaCentroamericana",
            "ExportacionesDeServicios",
            "VentasAZonasFrancasYDPATasaCero",
            "VentaACuentaDeTercerosNoDomiciliados",
            "TotalVentas",
            "TipoOperacionRenta",
            "TipoDeIngresoRenta",
            "NumeroDeAnexo"
          ]
        },
        {
          text: "Documentos Invalidados",
          value: "da",
          titleHeaders: [
            "NÚMERO DE RESOLUCIÓN",
            "CLASE DE DOCUMENTO",
            "DESDE (PREIMPRESO)",
            "HASTA (PREIMPRESO)",
            "TIPO DE DOCUMENTO",
            "TIPO DE DETALLE",
            "SERIE",
            "DESDE",
            "HASTA",
            "CÓDIGO DE GENERACIÓN"
          ],
          dataHeaders: [
            "NÚMERO DE RESOLUCIÓN",
            "CLASE DE DOCUMENTO",
            "DESDE (PREIMPRESO)",
            "HASTA (PREIMPRESO)",
            "TIPO DE DOCUMENTO",
            "TIPO DE DETALLE",
            "SERIE",
            "DESDE",
            "HASTA",
            "CÓDIGO DE GENERACIÓN"
          ]
        },
        {
          text: "Compras",
          value: "c",
          titleHeaders: [
              "FECHA DE EMISIÓN",
              "CLASE DE DOCUMENTO",
              "TIPO DE DOCUMENTO",
              "NÚMERO DE DOCUMENTO",
              "NIT O NRC DEL PROVEEDOR",
              "NOMBRE DEL PROVEEDOR",
              "COMPRAS INTERNAS EXENTAS Y/O NO SUJETAS",
              "INTERNACIONES EXENTAS Y/O NO SUJETAS",
              "IMPORTACIONES EXENTAS Y/O NO SUJETAS",
              "COMPRAS INTERNAS GRAVADAS",
              "INTERNACIONES GRAVADAS DE BIENES",
              "IMPORTACIONES GRAVADAS DE BIENES",
              "IMPORTACIONES GRAVADAS DE SERVICIOS",
              "CRÉDITO FISCAL",
              "TOTAL DE COMPRAS",
              "DUI DEL PROVEEDOR",
              "TIPO DE OPERACIÓN",
              "CLASIFICACIÓN",
              "SECTOR",
              "TIPO DE COSTO / GASTO",
              "NÚMERO DE ANEXO"
          ],
          dataHeaders:[
              "FECHA DE EMISIÓN",
              "CLASE DE DOCUMENTO",
              "TIPO DE DOCUMENTO",
              "NÚMERO DE DOCUMENTO",
              "NIT O NRC DEL PROVEEDOR",
              "NOMBRE DEL PROVEEDOR",
              "COMPRAS INTERNAS EXENTAS Y/O NO SUJETAS",
              "INTERNACIONES EXENTAS Y/O NO SUJETAS",
              "IMPORTACIONES EXENTAS Y/O NO SUJETAS",
              "COMPRAS INTERNAS GRAVADAS",
              "INTERNACIONES GRAVADAS DE BIENES",
              "IMPORTACIONES GRAVADAS DE BIENES",
              "IMPORTACIONES GRAVADAS DE SERVICIOS",
              "CRÉDITO FISCAL",
              "TOTAL DE COMPRAS",
              "DUI DEL PROVEEDOR",
              "TIPO DE OPERACIÓN",
              "CLASIFICACIÓN",
              "SECTOR",
              "TIPO DE COSTO / GASTO",
              "NÚMERO DE ANEXO"
          ],
        },
        /*{
          text: "Anticipo a cuenta al declarante",
          value: "img",
          titleHeaders: [
              "NIT AGENTE",
              "FECHA EMISIÓN DEL DOCUEMNTO",
              "SERIE DE DOCUMENTO",
              "NÚMERO DE DOCUMENTO",
              "Monto sujeto",
              "Monto del anticipo a cuenta 2%",
              "DUI AGENTE",
              "Número DE ANEXO"
          ],
          dataHeaders: [
              "NIT AGENTE",
              "FECHA EMISIÓN DEL DOCUEMNTO",
              "SERIE DE DOCUMENTO",
              "NÚMERO DE DOCUMENTO",
              "Monto sujeto",
              "Monto del anticipo a cuenta 2%",
              "DUI AGENTE",
              "Número DE ANEXO"
          ]
        }*/
        
       
      ],
     
      selectAll: false,
      deselectAll: false,
      selectedRadio: null,
      loading: false,
      vc: null,
      vcf: null,
      c: null,
      cse: null,
      da: null,
      ac: null,
      p: null,
      crr: null,
      img: null,
      rid: null,
      bi: null,
      pid: null,
      isProcessingExports: false,
      pendingExportQueue: [],
      pendingCsvDownload: null,
      exportRunId: 0,
      downloadedExportTokens: {},
      preserveDialogAfterExport: false,
    };
  },
  watch: {
    dataType(newVal) {
      this.search.dataType = newVal;
    },
  },
  mounted() {
    this.TipoPlan = JSON.parse(localStorage.getItem('user')).TipoPlan;
    this.search.dataType = this.dataType;
    this.generateYearList();
    this.setCurrentTime();
    this.getBranches();
    this.selectedOptions = [];
  },

  methods: {
    showAlert(type, header, body, options = null) {
      type = type == null ? "danger" : type;
      this.alert.type = type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options != null ? options : null;
    },

    async closeAlert() {
      this.alert.show = false;
      this.alert.options = null;
      this.loading = false;

      this.pendingCsvDownload = null;

      if (this.isProcessingExports) {
        await this.processNextExport();
      }
    },

    async acceptAlert() {
      const alertOptions = this.alert.options;
      this.alert.show = false;
      this.alert.options = null;

      if (alertOptions) {
        const callbackLabel =
          typeof alertOptions === "object"
            ? alertOptions.callbackLabel
            : alertOptions;

        if (callbackLabel && typeof this[callbackLabel] === "function") {
          await this[callbackLabel]();
          return;
        }
      }

      if (this.isProcessingExports) {
        await this.processNextExport();
      }
    },

    async showSelections() {
      //console.log(this.search);
      this.preserveDialogAfterExport = false;

      if (!this.selectedOptions || this.selectedOptions.length === 0) {
        this.showAlert(
          "warning",
          "Advertencia",
          "Seleccione al menos un tipo de CSV para exportar."
        );
        return;
      }

      if (this.isProcessingExports) {
        return;
      }

      this.pendingExportQueue = [...this.selectedOptions];
      this.pendingCsvDownload = null;
      this.exportRunId += 1;
      this.downloadedExportTokens = {};
      this.isProcessingExports = true;

      await this.processNextExport();
    },

    close() {
      this.preserveDialogAfterExport = false;
      this.$emit("close-csv");
    },
    setCurrentTime() {
      const currentTime = new Date();
      const currentUserBranch = JSON.parse(localStorage.getItem("user")).branch || "";
      this.search = {
        year: currentTime.getFullYear(),
        month: currentTime.getMonth() + 1,
        dataType: this.dataType,
        ID_Branch: currentUserBranch
      };
    },
    // To select all & unselect
    handleRadioClick(selectedValue) {
      const typeOption = (this.TipoPlan != 'Emprendedor' && this.TipoPlan != 'Ecoanual' && this.TipoPlan != 'Ecoanual CONAMYPE');
      const option = !typeOption ? this.options2 : this.options;
      if (selectedValue === "selectAll") {
        this.selectAllItems(option);
      } else if (selectedValue === "deselectAll") {
        this.deselectAllItems(option);
      }
    },
    selectAllItems(option) {
      this.selectedOptions = option.map((item) => item.value);
      this.deselectAll = false;
    },
    deselectAllItems() {
      this.selectedOptions = [];
      this.selectAll = false;
    },
    generateYearList() {
      const currentYear = new Date().getFullYear();
      const startYear = 2020;

      for (let year = currentYear; year >= startYear; year--) {
        this.yearList.push({ text: year.toString(), value: year });
      }
    },

    // Métodos para manejo de sucursales
    getBranches() {
      this.$API.branches
        .findBranches(JSON.parse(localStorage.getItem("user")).businessid)
        .then((data) => {
          // Agregar la opción "Todas" al inicio del array
          this.branches = [
            {
              BranchName: 'Todas las sucursales',
              ID_Branch: 'all'
            },
            ...data
          ];
          
          // Establecer la sucursal del localStorage como seleccionada por defecto
          const currentUserBranch = JSON.parse(localStorage.getItem("user")).branch || "";
          this.selectedBranch = currentUserBranch;
          this.search.ID_Branch = currentUserBranch;
          
          // Obtener el nombre de la sucursal actual
          const currentBranchData = data.find(branch => branch.ID_Branch == currentUserBranch);
          if (currentBranchData) {
            this.currentBranch = currentBranchData.BranchName;
          }
        })
        .catch((err) => {
          console.log("Error al obtener sucursales:", err);
          this.$toasted.error("Error al cargar las sucursales");
        });
    },

    onBranchChange(value) {
      this.selectedBranch = value;
      this.search.ID_Branch = value;
      
      if (value) {
        // Actualizar el nombre de la sucursal seleccionada
        const selectedBranchData = this.branches.find(branch => branch.ID_Branch == value);
        if (selectedBranchData) {
          this.currentBranch = selectedBranchData.BranchName;
        }
      } else {
        // Si se limpia la selección, volver a la sucursal por defecto del localStorage
        const defaultBranch = JSON.parse(localStorage.getItem("user")).branch;
        this.selectedBranch = defaultBranch;
        this.search.ID_Branch = defaultBranch;
        
        const defaultBranchData = this.branches.find(branch => branch.ID_Branch == defaultBranch);
        if (defaultBranchData) {
          this.currentBranch = defaultBranchData.BranchName;
        }
      }
    },

    // API calling
    async processNextExport() {
      if (!this.isProcessingExports) {
        return;
      }

      if (this.pendingExportQueue.length === 0) {
        this.finishExportProcess();
        return;
      }

      const selectedOption = this.pendingExportQueue.shift();
      this.loading = true;

      try {
        console.log("Enviando datos de búsqueda:", this.search);
        const result = await this.callApi(selectedOption);

        if (result && result.paused) {
          this.loading = false;
          return;
        }
      } catch (error) {
        console.error("Error calling APIs:", error);
        this.showAlert(
          "danger",
          "Error",
          `Ocurrió un error al exportar ${
            this.getOption(selectedOption)?.text || selectedOption
          }.`
        );
        this.loading = false;
        return;
      }

      this.loading = false;
      await this.processNextExport();
    },

    finishExportProcess() {
      this.loading = false;
      this.isProcessingExports = false;
      this.pendingExportQueue = [];
      this.pendingCsvDownload = null;
      if (!this.preserveDialogAfterExport) {
        this.close();
      }
    },

    async continuePendingCsvDownload() {
      const pendingDownload = this.pendingCsvDownload;
      this.pendingCsvDownload = null;

      if (pendingDownload) {
        this.downloadCsvOnce(
          pendingDownload.value,
          pendingDownload.data,
          pendingDownload.token,
          pendingDownload.fileName
        );
      }

      this.loading = false;
      await this.processNextExport();
    },

    async callApi(selectedOption) {
      console.log("corriendo", selectedOption);

      switch (selectedOption) {
        case "vc":
          return this.getSalesTaxpayer();
        case "vcf":
          return this.getFinalConsumerSales();
        case "da":
          return this.getCancelDocument();
        case "crr":
          return this.getWithholdingVoucherReceipts();
        case "c":
          return this.getPurchases();
        case "cse":
          return this.getPurcharsesExcludedSubject();
        case "p":
          return this.getPerception();
        case "ac":
          return this.getAdvanceAccount();
        case "img":
          return this.getMassiveExpensesEntries();
        case "rid":
          return this.getMassiveWithholdingCertificates();
        case "bi":
          return this.getMassiveBillingInvoices();
        case "pid":
          return this.getMassiveWithholdingMadeToDeclarant();
        default:
          console.log("seleccione un opcion");
          return { paused: false };
      }
    },

    handleStandardCsvDownload(value, data, token = this.buildDownloadToken(value)) {
      this.downloadCsvOnce(value, data, token);
      return { paused: false };
    },

    handleValidatedCsvExport(value, data) {
      const warningConfig = this.buildCsvWarningConfig(value, data);
      const downloadToken = this.buildDownloadToken(value);

      if (!warningConfig) {
        return this.handleStandardCsvDownload(value, data, downloadToken);
      }

      const fileBaseName = this.buildCsvDownloadBaseName(value);
      const fileName = `${fileBaseName}.csv`;
      this.pendingCsvDownload = {
        value,
        data,
        token: downloadToken,
        fileName,
      };
      this.preserveDialogAfterExport = true;

      this.showAlert(
        "questionHtmlBulkDownload",
        "Advertencia",
        warningConfig.message,
        {
          filesPools: warningConfig.errorRows.length
            ? [
                {
                  file_pool_name: warningConfig.filePoolName,
                  recordsets: [
                    this.buildAlertDownloadFile(
                      `${fileBaseName} (datos con errores)`,
                      warningConfig.errorRows
                    ),
                  ],
                },
              ]
            : [],
          downloadLabel: warningConfig.errorRows.length
            ? "Descargue el detalle de errores a continuación:"
            : "",
          callbackLabel: "continuePendingCsvDownload",
        }
      );

      return { paused: true };
    },

    buildDownloadToken(value) {
      return [
        this.exportRunId,
        value,
        this.search.year,
        this.search.month,
        this.search.dataType,
        this.search.ID_Branch || "",
      ].join("::");
    },

    downloadCsvOnce(
      value,
      data,
      token = this.buildDownloadToken(value),
      fileName = `${this.buildCsvDownloadBaseName(value)}.csv`
    ) {
      if (this.downloadedExportTokens[token]) {
        return false;
      }

      this.downloadedExportTokens = {
        ...this.downloadedExportTokens,
        [token]: true,
      };

      this.downloadCSV(value, data, fileName);
      return true;
    },

    buildAlertDownloadFile(fileName, data) {
      return {
        name: fileName,
        extension: "csv",
        onDownload: () => this.downloadErrorRowsCsv(fileName, data),
      };
    },

    buildCsvDownloadBaseName(value) {
      const { text } = this.getOption(value);
      return `${text} de ${this.monthList[this.search.month - 1].text}/${
        this.search.year
      } - (${getCurrentDateTimeString()})`;
    },

    buildCsvWarningConfig(value, data) {
      switch (value) {
        case "vc":
          return this.buildSalesTaxpayerWarningConfig(data);
        case "vcf":
          return this.buildFinalConsumerWarningConfig(data);
        case "c":
          return this.buildPurchasesWarningConfig(data);
        default:
          return null;
      }
    },

    buildSalesTaxpayerWarningConfig(data = []) {
      const seenCustomers = new Set();
      const errorRows = data.reduce((rows, item) => {
        const tipoIngreso = this.getFirstDefinedValue(item, [
          "TIPO DE INGRESO (Renta)",
          "TIPO DE INGRESO",
        ]);

        if (!this.isEmptyOrInvalid(tipoIngreso)) {
          return rows;
        }

        const customerName =
          this.getFirstDefinedValue(item, [
            "NOMBRE, RAZÓN SOCIAL O DENOMINACIÓN",
          ]) || "Cliente sin nombre";
        const customerDocument =
          this.getFirstDefinedValue(item, [
            "NIT O NRC DEL CLIENTE",
            "DUI DEL CLIENTE",
          ]) || "Sin documento";
        const customerId = this.getFirstDefinedValue(item, ["ID_Customer"]) || "";
        const customerKey = `${customerId}::${customerDocument}::${customerName}`;

        if (seenCustomers.has(customerKey)) {
          return rows;
        }

        seenCustomers.add(customerKey);

        rows.push({
          ID_Customer: customerId,
          "Nombre del cliente": customerName,
          "NIT o NRC": customerDocument,
          "Campos Faltantes": "Tipo de Ingreso",
          Observacion: `El cliente ${customerName} no tiene asignado el Tipo de Ingreso.`,
        });
        return rows;
      }, []);

      return this.buildWarningAlertPayload(
        "Observaciones de Ventas Contribuyente",
        errorRows,
        `Se detectaron ${errorRows.length} fila(s) con observaciones en Ventas Contribuyente. Puede descargar el detalle de errores y decidir si desea continuar con la descarga del CSV completo.`
      );
    },

    buildFinalConsumerWarningConfig(data = []) {
      const hasMissingTipoIngreso = data.some((item) =>
        this.isEmptyOrInvalid(
          this.getFirstDefinedValue(item, [
            "TipoDeIngresoRenta",
            "TIPO DE INGRESO (Renta)",
            "TIPO DE INGRESO",
          ])
        )
      );

      if (!hasMissingTipoIngreso) {
        return null;
      }

      const businessName = this.getBusinessName();

      return this.buildMessageOnlyWarningPayload(
        `El negocio actual (${businessName}) no tiene especificado el Tipo de Ingreso. Si continúa, se descargará el CSV completo.`
      );
    },

    buildPurchasesWarningConfig(data = []) {
      const requiredFields = [
        "TIPO DE OPERACIÓN",
        "CLASIFICACIÓN",
        "SECTOR",
        "TIPO DE COSTO / GASTO",
      ];
      const fieldLabels = {
        "TIPO DE OPERACIÓN": "Tipo de Operacion",
        "CLASIFICACIÓN": "Clasificacion",
        SECTOR: "Sector",
        "TIPO DE COSTO / GASTO": "Tipo de Costo / Gasto",
      };
      const seenProviders = new Set();
      const errorRows = data.reduce((rows, item) => {
        const providerName =
          this.getFirstDefinedValue(item, ["NOMBRE DEL PROVEEDOR"]) ||
          "Proveedor sin nombre";
        const providerDocument =
          this.getFirstDefinedValue(item, [
            "NIT O NRC DEL PROVEEDOR",
            "DUI DEL PROVEEDOR",
          ]) || "Sin documento";
        const purchaseOrderId =
          this.getFirstDefinedValue(item, ["ID_PurchaseOrder"]) || "";
        const missingFields = requiredFields.filter((field) =>
          this.isEmptyOrInvalid(item[field])
        );

        if (!missingFields.length) {
          return rows;
        }

        const providerKey = `${purchaseOrderId}::${providerDocument}::${providerName}`;

        if (seenProviders.has(providerKey)) {
          return rows;
        }

        seenProviders.add(providerKey);

        rows.push({
          ID_PurchaseOrder: purchaseOrderId,
          "Nombre Proveedor": providerName,
          "NIT o NRC": providerDocument,
          "Campos Faltantes": missingFields
            .map((field) => fieldLabels[field] || field)
            .join(" | "),
          Observacion:
            missingFields.length === 1
              ? `El proveedor ${providerName} tiene pendiente asignar ${fieldLabels[missingFields[0]] || missingFields[0]}.`
              : `El proveedor ${providerName} tiene pendientes los siguientes campos: ${missingFields
                  .map((field) => fieldLabels[field] || field)
                  .join(" | ")}.`,
        });

        return rows;
      }, []);

      return this.buildWarningAlertPayload(
        "Observaciones de Compras",
        errorRows,
        `Se detectaron ${errorRows.length} fila(s) con observaciones en Compras. Puede descargar el detalle de errores y decidir si desea continuar con la descarga del CSV completo.`
      );
    },

    buildWarningAlertPayload(filePoolName, errorRows, message) {
      if (!message || !errorRows.length) {
        return null;
      }

      return {
        message: this.escapeHtml(message).replace(/\n/g, "<br/>"),
        filePoolName,
        errorRows,
      };
    },

    buildMessageOnlyWarningPayload(message) {
      if (!message) {
        return null;
      }

      return {
        message: this.escapeHtml(message).replace(/\n/g, "<br/>"),
        filePoolName: "",
        errorRows: [],
      };
    },

    getFirstDefinedValue(item = {}, keys = []) {
      for (const key of keys) {
        if (Object.prototype.hasOwnProperty.call(item, key)) {
          return item[key];
        }
      }

      return null;
    },

    getBusinessName() {
      const user = JSON.parse(localStorage.getItem("user")) || {};
      return user.business || user.BusinessName || "Negocio";
    },

    isEmptyOrInvalid(value) {
      if (value === 0 || value === "0") {
        return false;
      }

      if (value == null) {
        return true;
      }

      const normalizedValue = String(value).trim();

      return (
        normalizedValue === "" ||
        normalizedValue.toLowerCase() === "null" ||
        normalizedValue === "--"
      );
    },

    escapeHtml(value = "") {
      return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    },

    async getAdvanceAccount() {
      const res = await this.$API.accountingreports.getAdvanceAccount({
        ...this.search,
      });
      this.ac = res.data.data;
      console.log(this.ac);
      return this.handleStandardCsvDownload("ac", this.ac);
    },

    async getMassiveExpensesEntries() {
      const res = await this.$API.accountingreports.getMassiveExpensesEntries({
        ...this.search,
      });
      this.img = res.data.data;
      console.log(this.img);
      return this.handleStandardCsvDownload("img", this.img);
    },

    async getMassiveWithholdingCertificates() {
      const res =
        await this.$API.accountingreports.getMassiveWithholdingCertificates({
          ...this.search,
        });
      this.rid = res.data.data;
      return this.handleStandardCsvDownload("rid", this.rid);
    },

    async getMassiveBillingInvoices() {
      const res = await this.$API.accountingreports.getMassiveBillingInvoices({
        ...this.search,
      });
      this.bi = res.data.data;
      return this.handleStandardCsvDownload("bi", this.bi);
    },

    async getMassiveWithholdingMadeToDeclarant() {
      const res = await this.$API.accountingreports.getMassiveWithholdingMadeToDeclarant({
        ...this.search,
      });
      this.pid = res.data.data;
      return this.handleStandardCsvDownload("pid", this.pid);
    },

    async getPerception() {
      const res = await this.$API.accountingreports.getPerception({
        ...this.search,
      });
      this.p = res.data.data;
      console.log(this.p);
      return this.handleStandardCsvDownload("p", this.p);
    },

    async getWithholdingVoucherReceipts() {
      const res =
        await this.$API.accountingreports.getWithholdingVoucherReceipts({
          ...this.search,
        });
      this.crr = res.data.data;
      return this.handleStandardCsvDownload("crr", this.crr);
    },

    async getCancelDocument() {
      const res = await this.$API.accountingreports.getCancelDocument({
        ...this.search,
      });
      this.da = res.data.data;
      console.log(this.da);
      return this.handleStandardCsvDownload("da", this.da);
    },

    async getSalesTaxpayer() {
      const res = await this.$API.accountingreports.getSalesTaxpayer({
        ...this.search,
      });
      this.vc = res.data.data;
      console.log(this.vc);
      return this.handleValidatedCsvExport("vc", this.vc);
    },

    async getFinalConsumerSales() {
      const res = await this.$API.accountingreports.getFinalConsumer({
        ...this.search,
      });
      console.log("final customer response ", res.data.data);
      this.vcf = res.data.data;
      return this.handleValidatedCsvExport("vcf", this.vcf);
    },

    // API call for Ventas Contribuyente (vc) and Ventas Consumidor final (vcf)
    async getReportSales(search, reportType) {
      const res = await this.$API.accountingreports.getSalesByDate({
        ...this.search,
        reportType: reportType,
        dataType: this.dataType,
      });

      if (reportType === "1") {
        this.vc = res.data.data;
        console.log(this.vc, "vc");
        return this.handleValidatedCsvExport("vc", this.vc);
      }

      this.vcf = res.data.data;
      console.log(this.vcf, "vcf");
      return this.handleValidatedCsvExport("vcf", this.vcf);
    },

    // API call for Comprars Sujetos Excluidos (cse)
    async getPurcharsesExcludedSubject() {
      console.log(this.search);
      const res = await this.$API.accountingreports.getPurcharsesExcludedSubject(
        { ...this.search }
      );
      this.cse = res.data.data;
      console.log(this.cse, "cse");
      return this.handleStandardCsvDownload("cse", this.cse);
    },

    // API call for Compras (c)
    async getPurchases() {
      const res = await this.$API.accountingreports.getPurchases({
        ...this.search,
      });
      this.c = res.data.data;
      console.log(this.c);
      return this.handleValidatedCsvExport("c", this.c);
    },

    validateDate() {
      if (this.search.month == null || this.search.year == null) {
        console.log("no fecha");
        return;
      }
    },

    downloadErrorRowsCsv(fileName, data = []) {
      const headers = data.length > 0 ? Object.keys(data[0]) : [];
      const csvContent = this.convertRowsToCsv(data, headers, true);

      this.downloadBlob(csvContent, fileName.endsWith(".csv") ? fileName : `${fileName}.csv`);
    },

    convertRowsToCsv(rows = [], headers = [], includeHeaders = false) {
      const escapeCsvValue = (value) => {
        const normalizedValue =
          value === null || typeof value === "undefined" ? "" : String(value);

        if (
          normalizedValue.includes(";") ||
          normalizedValue.includes('"') ||
          normalizedValue.includes("\n")
        ) {
          return `"${normalizedValue.replace(/"/g, '""')}"`;
        }

        return normalizedValue;
      };

      const lines = [];

      if (includeHeaders && headers.length > 0) {
        lines.push(headers.map((header) => escapeCsvValue(header)).join(";"));
      }

      rows.forEach((row) => {
        lines.push(
          headers.map((header) => escapeCsvValue(row[header])).join(";")
        );
      });

      return lines.join("\r\n");
    },

    downloadBlob(content, fileName, mimeType = "text/csv") {
      const blob = new Blob([content], { type: mimeType });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },

    //Download CSV
    downloadCSV(value, data, fileName = `${this.buildCsvDownloadBaseName(value)}.csv`) {
      const { dataHeaders } = this.getOption(value);
      // const csvContent = convertToCSV(data, dataHeaders, titleHeaders);
      const csvContent = convertToCSV(data, dataHeaders);
      this.downloadBlob(csvContent, fileName);
    },
    getOption(value) {
      // Buscar primero en options principales
      let option = this.options.find((option) => option.value === value);
      
      // Si no se encuentra, buscar en options2 (para planes Emprendedor/Ecoanual)
      if (!option) {
        option = this.options2.find((option) => option.value === value);
      }
      
      return option;
    },
  },
};
</script>

<style scoped>
.btndelete {
  background-color: #e3191e !important;
  color: white;
}

.btndisable {
  background-color: #41464c !important;
  color: white;
}

.btn-add {
  max-width: 100% !important;
  width: max-content;
}

@media (min-height: 1460px) {
  .tablesize {
    max-height: 100%;
  }
}

@media (min-height: 1060px) and (max-height: 1459px) {
  .tablesize {
    max-height: 100%;
  }
}
@media (min-height: 930px) and (max-height: 1059px) {
  .tablesize {
    max-height: 100%;
  }
}
@media (min-height: 860px) and (max-height: 929px) {
  .tablesize {
    max-height: 100%;
  }
}
@media (min-height: 660px) and (max-height: 859px){
  .tablesize {
    max-height: 600px;
    overflow-y: scroll;
  }
}
@media (min-height: 460px) and (max-height: 659px) {
  .tablesize {
    max-height: 400px;
    overflow-y: scroll;
  }
}
@media (max-height: 459px) {
  .tablesize {
    max-height: 250px;
    overflow-y: scroll;
  }
}
</style>
